// extracted by mini-css-extract-plugin
module.exports = {"action":"AvatarEditPopup_action__la9UT","actionButton":"AvatarEditPopup_actionButton__3l3pH"};